import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  forwardRef,
  Input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'gtd-checkbox-with-label',
  templateUrl: './checkbox-with-label.component.html',
  styleUrls: ['./checkbox-with-label.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxWithLabelComponent),
      multi: true,
    },
  ],
})
export class CheckboxWithLabelComponent implements ControlValueAccessor {
  @ContentChild('labelTpl', { read: TemplateRef }) public labelTpl: TemplateRef<unknown>;
  @Input() showLabel = false;
  @Input() label: string;

  public data: boolean;
  public disabled = false;
  public requiredValidator = false;
  public invalid = false;
  private onChange: (value: boolean) => void = () => {};
  private onTouch: () => void = () => {};

  constructor(private cd: ChangeDetectorRef) {}

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(data: boolean): void {
    this.data = data;
    this.cd.markForCheck();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  changeData(value: boolean): void {
    this.data = value;
    this.onChange(value);
    this.onTouch();
  }
}
